// getters
const schoolroutesReports = state => state.schoolroutesReports

export default {
  schoolroutesReports
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/reports/getters.js